import { IsServerSideRendering, isPhoneOrTablet } from '../../utilities';
import theme from '../../theme';

const SCREEN_RESIZE = '@@ui/SCREEN_RESIZE';
const SCREEN_ORIENTATION = '@@ui/SCREEN_ORIENTATION';

function screenResize(payload) {
  return {
    type: SCREEN_RESIZE,
    payload,
  };
}

function screenOrientation() {
  return {
    type: SCREEN_ORIENTATION,
  };
}

// TODO: add window check to make sure we are not on server
export function initResizeListener(store) {
  const DEFAULT_HEIGHT = 1000;
  const DEFAULT_WIDTH = theme.breakpoints.values.lg;

  store.dispatch(screenResize({
    height: (IsServerSideRendering) ? DEFAULT_HEIGHT : window.innerHeight,
    width: (IsServerSideRendering) ? DEFAULT_WIDTH : window.innerWidth,
  }));

  if (IsServerSideRendering) {
    return;
  }

  let timeout;
  window.addEventListener(
    'resize',
    () => {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      timeout = window.requestAnimationFrame(() => {
        store.dispatch(screenResize({ height: window.innerHeight, width: window.innerWidth }));
      });
    },
    false,
  );

  let orientationTimeout;
  window.addEventListener(
    'orientationchange',
    () => {
      if (orientationTimeout) {
        window.cancelAnimationFrame(orientationTimeout);
      }

      orientationTimeout = window.requestAnimationFrame(() => {
        store.dispatch(screenOrientation());
      });
    },
    false,
  );
}

function getSizes({ height, width }) {
  const widthXs = width < theme.breakpoints.values.sm;
  const widthSm = width >= theme.breakpoints.values.sm && width < theme.breakpoints.values.md;
  const widthMd = width >= theme.breakpoints.values.md && width < theme.breakpoints.values.lg;
  const widthLg = width >= theme.breakpoints.values.lg && width < theme.breakpoints.values.xl;
  const widthXl = width >= theme.breakpoints.values.xl;
  const isPortrait = (IsServerSideRendering) ? false : window.innerHeight > window.innerWidth;
  const isLandscape = (IsServerSideRendering) ? true : window.innerHeight < window.innerWidth;

  return {
    screenSize: {
      width,
      height,
      widthXs,
      widthSm,
      widthMd,
      widthLg,
      widthXl,
      isPortrait,
      isLandscape,
      isMobile: widthXs,
      isTablet: widthSm,
      isDesktop: widthMd || widthLg || widthXl,
      isPhoneOrTablet: isPhoneOrTablet()
    }
  };
}

export default function ui(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case SCREEN_RESIZE: {
      return {
        ...state,
        ...getSizes(payload),
      };
    }

    default:
      return state;
  }
}
